import {
    FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST,
    FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS,
    FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE,
    UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST,
    UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS,
    UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE,
  } from './types';
  
  import {
    fetchAllContactSupportMessages,
    updateContactSupportMessage,
  } from '../../services/contactSpportService';
  
  // Action Creators
  
  // Fetch Contact Support Messages Action Creators
  export const fetchContactSupportMessagesRequest = () => ({ 
    type: FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST 
  });
  
  export const fetchContactSupportMessagesSuccess = (messagesData) => ({
    type: FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS,
    payload: messagesData,
  });
  
  export const fetchContactSupportMessagesFailure = (error) => ({
    type: FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE,
    payload: error,
  });
  
  // Update Contact Support Message Action Creators
  export const updateContactSupportMessageRequest = () => ({ 
    type: UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST 
  });
  
  export const updateContactSupportMessageSuccess = (messageData) => ({
    type: UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS,
    payload: messageData,
  });
  
  export const updateContactSupportMessageFailure = (error) => ({
    type: UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE,
    payload: error,
  });
  
  // Thunks (Asynchronous Action Creators)
  
  // Thunk to fetch all contact support messages
  export const fetchContactSupportMessagesAction = (filters = {}) => async (dispatch) => {
    dispatch(fetchContactSupportMessagesRequest());
  
    try {
      const response = await fetchAllContactSupportMessages(filters);
  
      if (response.error) {
        dispatch(fetchContactSupportMessagesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchContactSupportMessagesSuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(fetchContactSupportMessagesFailure(error.message || "Failed to fetch contact support messages"));
      return { success: false, error: error.message || "Failed to fetch contact support messages" };
    }
  };
  
  // Thunk to update a contact support message
  export const updateContactSupportMessageAction = (messageId, updateData) => async (dispatch) => {
    dispatch(updateContactSupportMessageRequest());
  
    try {
      const response = await updateContactSupportMessage(messageId, updateData);
  
      if (response.error) {
        dispatch(updateContactSupportMessageFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(updateContactSupportMessageSuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(updateContactSupportMessageFailure(error.message || "Failed to update contact support message"));
      return { success: false, error: error.message || "Failed to update contact support message" };
    }
  };
  